import React, { useState, useEffect } from 'react';
import siteLogo from '../images/sitelogo.png';

interface NavigationLink {
  label: string;
  route: string;
}

const navigationLinks: NavigationLink[] = [
  { label: 'Browse Hacks', route: 'https://disabilityhackshub.netlify.app/' },
  //{ label: 'Community', route: 'https://disabilityhackshub.com/community/' },
  //{ label: 'Resources', route: 'https://disabilityhackshub.com/resources/' },
  { label: 'Submit', route: 'https://disabilityhackshub.com/submit/' },
  { label: 'Contact', route: 'https://disabilityhackshub.com/contact/' },
];

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    return () => {
      document.body.classList.remove('mobile-menu-open');
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="color-scheme-1 border-b-0 w-full min-h-[4.5rem] bg-hackGreen-100 flex items-center">
      <div className="w-full max-w-screen-2xl mx-auto grid grid-cols-[auto_1fr_auto] items-center min-h-[4.5rem] px-[5%]">
        {/* Left: Navigation */}
        <nav className="hidden lg:flex items-center space-x-2 justify-start">
          {navigationLinks.map((link) => (
            <a
              key={link.route}
              href={link.route}
              className="navbar3_link text-gray-800 hover:text-hackGreen-600 font-normal px-4 py-2 text-base"
              style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 400 }}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={toggleMobileMenu}
          className="navbar3_menu-button lg:hidden flex items-center justify-center w-12 h-12"
          aria-label="Toggle menu"
        >
          <div className="menu-icon3 flex flex-col justify-center items-center">
            <span className="menu-icon3_line-top w-6 h-0.5 bg-black mb-1.5"></span>
            <span className="menu-icon3_line-middle w-6 h-0.5 bg-black my-1.5"></span>
            <span className="menu-icon3_line-bottom w-6 h-0.5 bg-black mt-1.5"></span>
          </div>
        </button>

        {/* Center: Logo */}
        <div className="flex justify-center">
          <a href="https://disabilityhackshub.com/" className="navbar3_logo-link flex items-center" aria-label="Disability Hacks Hub Home">
            <img 
              src={siteLogo} 
              alt="Disability Hacks Hub Logo" 
              className="navbar3_logo"
              style={{ height: '44px', width: 'auto' }}
            />
          </a>
        </div>

        {/* Right: Submit Hack Button */}
        <div className="flex justify-end">
          <a
            href="https://disabilityhackshub.com/submit/"
            className="button shadow-md px-6 py-2 border border-black bg-white text-black rounded-md ml-auto"
            style={{ fontWeight: 500 }}
          >
            Submit Hack
          </a>
        </div>
      </div>

      {/* Mobile Menu */}
      <div 
        className={`navbar3_menu lg:hidden fixed top-0 left-0 w-[80vw] h-[100dvh] bg-hackGreen-100 border-r border-black p-[5vw] pb-[6.5rem] overflow-auto transition-transform duration-500 ease-in-out ${
          mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <nav className="flex flex-col space-y-4 mt-16">
          {navigationLinks.map((link) => (
            <a
              key={link.route}
              href={link.route}
              className="navbar3_link text-gray-800 hover:text-hackGreen-600 font-normal text-lg"
              style={{ fontFamily: 'Manrope, sans-serif', fontWeight: 400 }}
              onClick={() => setMobileMenuOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>

      {/* Background Overlay */}
      {mobileMenuOpen && (
        <div 
          className="navbar3_menu-background fixed inset-0 bg-black/50 z-0 lg:hidden"
          onClick={() => setMobileMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default Header;
